import { addToSyncQueue, removeFromFailed } from "./roomSyncStatusSlice"
import { AppDispatch } from "./store"

export const retrySyncSingleRoom = (jid: string) => {
  return async (dispatch: AppDispatch) => {
    dispatch(removeFromFailed({ jid }))
    dispatch(addToSyncQueue({ jid }))
  }
}
